module.exports = __webpack_public_path__ + "img/material-complementario.06dbfac1.svg";